import { React } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Typography, Button } from "@material-ui/core";
import useStyles from "./styles.js";
import hacker from "../../images/hacker.png";

const Home = () => {
    const classes = useStyles();

    let navigate = useNavigate();
    const routeChange = () => {
        let path = `/research`;
        window.scrollTo(0, 0);
        navigate(path);
    };

    return (
        <div className={classes.main}>
            <div className={classes.logoContainer}>
                <img src={hacker} className={classes.logo} alt="Logo" height="500px"></img>
                <h2 className={classes.header}>
                    <div className={classes.teamName}>
                        QCrypt <br></br>
                        <div className={classes.teamDescription}>Gemstone Class of 2025</div>
                    </div>
                </h2>
            </div>
            <div className={classes.meetTheTeam}>
                <Typography variant="h3" className={classes.introductionTitle}>
                    About Us
                </Typography>
                <Typography variant="h6" className={classes.introduction}>
                    Team QCrypt is a class of 2025 Gemstone research team at the University of
                    Maryland. Our team members include Adnan Benchaaboun, Ayman Chowdhury, Sahil
                    Gaba, Julian Javi, Lucas LaBuff, Andrew Parker, Alexander Yelovich, and Evan
                    Serafin. Our mentor is &nbsp;
                    <a
                        href="https://www.cs.umd.edu/~jkatz/"
                        target="_blank"
                        rel="noreferrer"
                        className={classes.teamMentor}
                    >
                        Jonathan Katz &nbsp;
                    </a>
                    and our librarian is &nbsp;
                    <a
                        href="https://www.lib.umd.edu/about/contact/directory/zaida-diaz"
                        target="_blank"
                        rel="noreferrer"
                        className={classes.teamMentor}
                    >
                        Zaida Diaz .
                    </a>
                    <Typography className={classes.research} variant="h6">
                        {" "}
                        QCrypt aims to research and improve cryptographic algorithms in order to
                        resist attacks from quantum computers.
                    </Typography>
                    <Button
                        className={classes.buttonSubmit}
                        variant="contained"
                        size="large"
                        onClick={routeChange}
                    >
                        Learn More
                    </Button>
                </Typography>
            </div>
        </div>
    );
};

export default Home;
